import { css } from 'styled-components';

export const lineClampCss = ($lines = 1) => css`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${$lines};
  display: -webkit-box !important;
  white-space: initial;
`;
